/**
 * Takes a file and returns a promise to a base64 encoded data URL containing file contents
 * @param file - File to read
 */
export const toBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });
};
